export default __webpack_public_path__ + "lang/sv_SE.mo";